const toKeys = (arr, key) => {
  return arr?.map((obj) => obj[key]);
};

export const toIds = (arr) => toKeys(arr, 'id');
